import { useState, useEffect, useMemo, useCallback } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip, GeoJSON, useMap } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import Papa from 'papaparse';
import 'leaflet/dist/leaflet.css';
import './MapComponent.css';

// Password protection - Change this to your desired password
const MAP_PASSWORD = 'admin1234';
const SESSION_KEY = 'defensafe_map_auth_v2';

const csvData = `Arabic Name,Latitude,Longitude,Source URL
هوليدي بيتش,35.0103338,35.9009831,"https://maps.google.com/?q=35.0103338,35.9009831"
معمل الادوية,34.7404554,35.9605068,"https://maps.google.com/?q=34.7404554,35.9605068"
شاحنات الغاز بانياس,35.2281256,35.9673481,"https://maps.google.com/?q=35.2281256,35.9673481"
مكتب الشيخ ابو عبد الله,34.901419,35.8799568,"https://maps.google.com/?q=34.901419,35.8799568"
شركة الغريواتي,33.4384503,36.2969549,"https://maps.google.com/?q=33.4384503,36.2969549"
مستودع السبينة,33.4285683,36.2895779,"https://maps.google.com/?q=33.4285683,36.2895779"
دفنشي البرامكة,33.5087952,36.2803309,"https://maps.google.com/?q=33.5087952,36.2803309"
دفنشي المزة,33.5023102,36.2567151,"https://maps.google.com/?q=33.5023102,36.2567151"
معمل الرخام عذرا,33.6460601,36.5791904,"https://maps.google.com/?q=33.6460601,36.5791904"
البنك العربي السوري,33.5177172,36.2852576,"https://maps.google.com/?q=33.5177172,36.2852576"
معمل دفنشي السبينة ريف,33.4085767,36.2522667,"https://maps.google.com/?q=33.4085767,36.2522667"
أقمار صيدنايا  ريف,33.6684048,36.3637496,"https://maps.google.com/?q=33.6684048,36.3637496"
السكنة,33.5091091,36.0915562,"https://maps.google.com/?q=33.5091091,36.0915562"
معمل البلاستيك عذرا,33.61742,36.6049783,"https://maps.google.com/?q=33.61742,36.6049783"
المجبل عذرا,33.6329978,36.5702292,"https://maps.google.com/?q=33.6329978,36.5702292"
معمل البطاريات عذرا,33.6327433,36.5624967,"https://maps.google.com/?q=33.6327433,36.5624967"
السفارة الإيرانية,33.4989692,36.2373588,"https://maps.google.com/?q=33.4989692,36.2373588"
معمل الحلاوة ريف,33.420449,36.3686743,"https://maps.google.com/?q=33.420449,36.3686743"
فيلاة حافظ يعفور,33.5048627,36.0999543,"https://maps.google.com/?q=33.5048627,36.0999543"
كراج اكلين نظافة,33.4997147,36.3166261,"https://maps.google.com/?q=33.4997147,36.3166261"
مبنى الاسود,33.4930751,36.2357621,"https://maps.google.com/?q=33.4930751,36.2357621"
مبنى اتصالات النصر,33.5110844,36.2968134,"https://maps.google.com/?q=33.5110844,36.2968134"
نقطتة ابو رمانة,33.5190998,36.2828869,"https://maps.google.com/?q=33.5190998,36.2828869"
الشركة السورية للاتصالات الباب الشرقي,33.4928285,36.2395767,"https://maps.google.com/?q=33.4928285,36.2395767"
الشركة السورية للاتصالات الباب الغربي,33.4921355,36.2384269,"https://maps.google.com/?q=33.4921355,36.2384269"
الهيئة الناظمة للاتصالات,33.492432,36.2373324,"https://maps.google.com/?q=33.492432,36.2373324"
فيلاة قدورة 1,33.507912,36.1032661,"https://maps.google.com/?q=33.507912,36.1032661"
فيلاة فايز جمعة,33.5160917,36.0843083,"https://maps.google.com/?q=33.5160917,36.0843083"
فيلاة قدورة 2,33.5126033,36.0924935,"https://maps.google.com/?q=33.5126033,36.0924935"
كابلات مع المرآب,35.51633834838867,35.822731018066406,"https://maps.google.com/?q=35.51633834838867,35.822731018066406"
مقسم دمسرخو,35.55302078898418,35.77689170837402,"https://maps.google.com/?q=35.55302078898418,35.77689170837402"
مطعم فيو,35.4976192,35.7797733,"https://maps.google.com/?q=35.4976192,35.7797733"
معمل الكومندو,35.366885,35.9407867,"https://maps.google.com/?q=35.366885,35.9407867"
بريد الشاطئ الأزرق,35.584112,35.7455176,"https://maps.google.com/?q=35.584112,35.7455176"
معمل اللواقط,35.52952830139315,35.83047151565552,"https://maps.google.com/?q=35.52952830139315,35.83047151565552"
دافنشي,35.5163494,35.7709472,"https://maps.google.com/?q=35.5163494,35.7709472"
مكاتب,35.3408524,40.1223725,"https://maps.google.com/?q=35.3408524,40.1223725"
محطة التبني,35.6328738,39.7584327,"https://maps.google.com/?q=35.6328738,39.7584327"
جبل الحجيف,35.4129283,40.0285883,"https://maps.google.com/?q=35.4129283,40.0285883"
بريد الانصاري,36.1869728,37.1296169,"https://maps.google.com/?q=36.1869728,37.1296169"
بريد الجميلية,36.2070167,37.1455017,"https://maps.google.com/?q=36.2070167,37.1455017"
بريد سناء محيدلي,36.1974617,37.1788468,"https://maps.google.com/?q=36.1974617,37.1788468"
بريد الاتحاد السكني,36.2246304,37.0925052,"https://maps.google.com/?q=36.2246304,37.0925052"
مستودع العامرية,36.1735713,37.1271856,"https://maps.google.com/?q=36.1735713,37.1271856"
بريد الحمدانية,36.180357,37.1154305,"https://maps.google.com/?q=36.180357,37.1154305"
برج أجز,35.938050757789036,36.8706164136529,"https://maps.google.com/?q=35.938050757789036,36.8706164136529"
برج الصاخور,36.213174,37.1924137,"https://maps.google.com/?q=36.213174,37.1924137"
معمل صهر الحديد وتين,36.1877901,37.2747349,"https://maps.google.com/?q=36.1877901,37.2747349"
مكتب الفرقان,36.2046548,37.1113173,"https://maps.google.com/?q=36.2046548,37.1113173"

معمل الشرق لدرفلة الحديد,36.1881944,37.2709905,"https://maps.google.com/?q=36.1881944,37.2709905"
معمل درفلة الحديد تيارة,36.1949058,37.3029146,"https://maps.google.com/?q=36.1949058,37.3029146"
مجبل الباطون,36.2665514,37.2985081,"https://maps.google.com/?q=36.2665514,37.2985081"
معمل الدباغة,36.2396903,37.1727281,"https://maps.google.com/?q=36.2396903,37.1727281"
منزل عبد القادر العيدو ابو صطوف . جهة خاصة,36.238121032714844,37.20594024658203,"https://maps.google.com/?q=36.238121032714844,37.20594024658203"
برج كباجب,35.0812728,39.6830417,"https://maps.google.com/?q=35.0812728,39.6830417"
برج نصيب,32.5519025,36.1851815,"https://maps.google.com/?q=32.5519025,36.1851815"
برج نصيب المناوبون يوسف الراضي,32.68511192120902,36.21077589690685,"https://maps.google.com/?q=32.68511192120902,36.21077589690685"
برج درعا المدينة,32.6248456,36.1029241,"https://maps.google.com/?q=32.6248456,36.1029241"
برج كلماخو,35.4528048,35.9629683,"https://maps.google.com/?q=35.4528048,35.9629683"
برج جاسم درعا,32.99297879212473,36.04743305593729,"https://maps.google.com/?q=32.99297879212473,36.04743305593729"
برج الحارة,33.05619066311792,36.00107107311487,"https://maps.google.com/?q=33.05619066311792,36.00107107311487"
صالحية البوكمال,34.7274633,40.7401983,"https://maps.google.com/?q=34.7274633,40.7401983"
الحراك 2,32.7465265,36.3101565,"https://maps.google.com/?q=32.7465265,36.3101565"
برج ازرع ذنيبة,32.8519024,36.225016,"https://maps.google.com/?q=32.8519024,36.225016"
برج صيدنايا,33.69581604003906,36.37171173095703,"https://maps.google.com/?q=33.69581604003906,36.37171173095703"
برج سفير معلولا,33.84599285882043,36.545103527605534,"https://maps.google.com/?q=33.84599285882043,36.545103527605534"
برج الجسر السابع دمشق,33.4555692,36.3716795,"https://maps.google.com/?q=33.4555692,36.3716795"
برج مدخل الزبداني ١,33.6016768,36.0538952,"https://maps.google.com/?q=33.6016768,36.0538952"
برج خان الشيح,34.6635753,36.3939813,"https://maps.google.com/?q=34.6635753,36.3939813"
موقع دير العصافير,33.4652481,36.4183598,"https://maps.google.com/?q=33.4652481,36.4183598"
برج كروم مضايا,33.6897812,36.0438004,"https://maps.google.com/?q=33.6897812,36.0438004"
برج عقربا,33.4734781,36.3549253,"https://maps.google.com/?q=33.4734781,36.3549253"
مدينةالشباب,33.4918533,36.2453309,"https://maps.google.com/?q=33.4918533,36.2453309"
مستودع الصبورة,33.5312267,36.1200081,"https://maps.google.com/?q=33.5312267,36.1200081"
برج الجسر الثالث,33.4553364,36.3717233,"https://maps.google.com/?q=33.4553364,36.3717233"
بناء المهندسين,33.5046779,36.2602897,"https://maps.google.com/?q=33.5046779,36.2602897"
برج مضايا,33.6460875,36.0785328,"https://maps.google.com/?q=33.6460875,36.0785328"
برج مدخل الزبداني ٢,33.60548,36.050015,"https://maps.google.com/?q=33.60548,36.050015"
موقع لونا فيردي طريق لبنان,33.56124439188343,36.076171919703484,"https://maps.google.com/?q=33.56124439188343,36.076171919703484"
موقع المرصد جديدة يابوس,33.6639217,35.9901067,"https://maps.google.com/?q=33.6639217,35.9901067"
موقع زيبورد . الحدود . جديدة يابوس,33.6914567,35.968505,"https://maps.google.com/?q=33.6914567,35.968505"
موقع دام ليب  3 عند الحاجز طريق لبنان,33.6361873,35.9780157,"https://maps.google.com/?q=33.6361873,35.9780157"
موقع دام ليب  4 . وادي القرن,33.6246435,35.9904899,"https://maps.google.com/?q=33.6246435,35.9904899"
موقع ام . دام ليب 4  القصر المهجور طريق لبنان,33.620183,36.018293,"https://maps.google.com/?q=33.620183,36.018293"
موقع حينا . جبل الشيخ,33.3494929,35.9418799,"https://maps.google.com/?q=33.3494929,35.9418799"
موقع سعسع . جبل الشيخ,33.2820138,36.0180228,"https://maps.google.com/?q=33.2820138,36.0180228"
موقع كناكر . جبل الشيخ,33.2678495,36.0944174,"https://maps.google.com/?q=33.2678495,36.0944174"
موقع جديدة الخاص . طريق المطار,33.40419037974208,36.5442331507802,"https://maps.google.com/?q=33.40419037974208,36.5442331507802"
موقع الهيجانة,33.3576581,36.5441749,"https://maps.google.com/?q=33.3576581,36.5441749"
موقع سرايا الصراع . عرطوز,33.4430657,36.1713431,"https://maps.google.com/?q=33.4430657,36.1713431"
موقع  C2  ضاحية قدسيا,33.534916,36.1857429,"https://maps.google.com/?q=33.534916,36.1857429"
موقع دير العصافير . ريف,33.465581,36.4185625,"https://maps.google.com/?q=33.465581,36.4185625"
موقع بردى . وادي بردى,33.6056448,36.1186406,"https://maps.google.com/?q=33.6056448,36.1186406"
موقع جرمانا . دير الخليل,33.4967796,36.335318,"https://maps.google.com/?q=33.4967796,36.335318"
موقع النشابية,33.5139036,36.4873402,"https://maps.google.com/?q=33.5139036,36.4873402"
موقع  B4  ضاحية الشام,33.58693468170282,36.37703362852335,"https://maps.google.com/?q=33.58693468170282,36.37703362852335"
موقع  C 6  ضاحية الشام,33.58102307545568,36.36408057063818,"https://maps.google.com/?q=33.58102307545568,36.36408057063818"
موقع حرجلة  . حرجلة,33.3732723,36.3159166,"https://maps.google.com/?q=33.3732723,36.3159166"
موقع يعفور  1  جانب رامي مخلوف,33.4941219,36.0949375,"https://maps.google.com/?q=33.4941219,36.0949375"
موقع يعفور  2  جانب أحمد حمشو,33.508895,36.0863833,"https://maps.google.com/?q=33.508895,36.0863833"
موقع يعفور  3  الطريق الغربي جانب الشاليهات,33.5307633,36.0613933,"https://maps.google.com/?q=33.5307633,36.0613933"
موقع برزة البلد . بناية الزهراوي,33.5608244,36.3235046,"https://maps.google.com/?q=33.5608244,36.3235046"
موقع لمعضمية . شارع الروضه,33.46113204956055,36.19651412963867,"https://maps.google.com/?q=33.46113204956055,36.19651412963867"
موقع يعفور . جانب النادي,33.5215816,36.0887617,"https://maps.google.com/?q=33.5215816,36.0887617"
موقع الملح . دمشق,33.5054922,36.3123789,"https://maps.google.com/?q=33.5054922,36.3123789"
موقع الفحامة . دمشق,33.5034731,36.2939631,"https://maps.google.com/?q=33.5034731,36.2939631"
موقع كفر سوسة . دمشق,33.4954709,36.2735154,"https://maps.google.com/?q=33.4954709,36.2735154"
موقع عقدة القصر . دمشق,33.488301,36.2250066,"https://maps.google.com/?q=33.488301,36.2250066"
موقع قصر الشعب . دمشق,33.5139617,36.2438033,"https://maps.google.com/?q=33.5139617,36.2438033"
موقع المهاجرين الجادة الرابعة . دمشق,33.5250328,36.2757183,"https://maps.google.com/?q=33.5250328,36.2757183"
موقع كشكول . دمشق,33.4973893,36.330339,"https://maps.google.com/?q=33.4973893,36.330339"
موقع الروضه . زاهرة . دمشق,33.491613,36.3073486,"https://maps.google.com/?q=33.491613,36.3073486"
موقع النخلة. جانب مشفى الفيحاء . زاهرة . دمشق,33.4893856,36.3018859,"https://maps.google.com/?q=33.4893856,36.3018859"
موقع سيدي مقداد . زاهرة . دمشق,33.4795786,36.3303054,"https://maps.google.com/?q=33.4795786,36.3303054"
موقع تضامن . دخلة الموصلي . دمشق,33.4809997,36.3146071,"https://maps.google.com/?q=33.4809997,36.3146071"
موقع خالد بن الوليد . فوق مبنى الإطفاء,33.4831948,36.2922975,"https://maps.google.com/?q=33.4831948,36.2922975"
موقع دعبول  . دمشق,33.4808001,36.3055213,"https://maps.google.com/?q=33.4808001,36.3055213"
مستودع الغريواتي صحنايا,33.5001098,36.2537267,"https://maps.google.com/?q=33.5001098,36.2537267"
فيلة ام كامل,33.4360768,36.2604602,"https://maps.google.com/?q=33.4360768,36.2604602"
الصبور مستودع خالد قدورة,33.5555415,36.1363631,"https://maps.google.com/?q=33.5555415,36.1363631"
نقطة يعفور حامد حسن,33.5279166,36.1284128,"https://maps.google.com/?q=33.5279166,36.1284128"
كابيتال للصرافة,33.5030913,36.0925296,"https://maps.google.com/?q=33.5030913,36.0925296"`;

// Custom pin icons with distance-based glow
const createIcon = (isDark, isHighlighted = false, glowIntensity = 1) => new L.Icon({
  iconUrl: isDark ? '/pin-light.png' : '/pin-dark.png',
  iconSize: [25, 35],
  iconAnchor: [12, 35],
  tooltipAnchor: [1, -35],
  className: `custom-pin-icon ${isHighlighted ? 'highlighted' : ''} glow-${Math.round(glowIntensity * 3)}`,
});

// Calculate distance between two points in kilometers
function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

// Calculate glow intensity based on nearby pins
function calculateGlowIntensity(currentLocation, allLocations, currentZoom = 7) {
  const zoomFactor = Math.max(0.3, Math.min(1, currentZoom / 10));
  const baseDistance = 50 / zoomFactor; // Base distance in km, adjusted by zoom
  
  const nearbyPins = allLocations.filter(loc => {
    if (loc.id === currentLocation.id) return false;
    const distance = calculateDistance(
      currentLocation.lat, currentLocation.lng,
      loc.lat, loc.lng
    );
    return distance < baseDistance;
  });

  if (nearbyPins.length === 0) return 1; // Full glow if no nearby pins
  if (nearbyPins.length >= 5) return 0.3; // Minimal glow if many nearby pins
  
  // Gradual reduction based on nearby pin count
  return Math.max(0.3, 1 - (nearbyPins.length * 0.15));
}

function FitBounds({ locations }) {
  const map = useMap();
  useEffect(() => {
    if (locations.length > 0) {
      const bounds = L.latLngBounds(locations.map(loc => [loc.lat, loc.lng]));
      map.fitBounds(bounds, { padding: [80, 80] });
    }
  }, [locations, map]);
  return null;
}

function ZoomTracker({ onZoomChange }) {
  const map = useMap();
  
  useEffect(() => {
    const handleZoom = () => {
      onZoomChange(map.getZoom());
    };
    
    map.on('zoomend', handleZoom);
    handleZoom(); // Set initial zoom
    
    return () => {
      map.off('zoomend', handleZoom);
    };
  }, [map, onZoomChange]);
  
  return null;
}

function SyrianBorder({ isDark }) {
  const [geoData, setGeoData] = useState(null);
  const [breathState, setBreathState] = useState(0);

  useEffect(() => {
    // Breathing animation - slower smooth pulse effect
    const breathInterval = setInterval(() => {
      setBreathState(prev => (prev + 1) % 120);
    }, 50);
    
    return () => clearInterval(breathInterval);
  }, []);

  useEffect(() => {
    const osmBoundaryUrl = 'https://nominatim.openstreetmap.org/details.php?osmtype=R&osmid=184840&polygon_geojson=1&format=json';
    
    const fetchSyriaBorder = async () => {
      try {
        const res = await fetch(osmBoundaryUrl);
        if (res.ok) {
          const data = await res.json();
          if (data && data.geometry) {
            const syriaFeature = {
              type: 'Feature',
              properties: { name: 'Syria' },
              geometry: data.geometry
            };
            setGeoData(syriaFeature);
            return;
          }
        }
      } catch (err) {
        console.warn('OSM Boundaries failed, trying fallback:', err);
      }
      
      const fallbackSources = [
        'https://raw.githubusercontent.com/georgique/world-geojson/develop/countries/syria.json',
        'https://raw.githubusercontent.com/glynnbird/countriesgeojson/master/syria.geojson'
      ];
      
      for (const url of fallbackSources) {
        try {
          const res = await fetch(url);
          if (res.ok) {
            const data = await res.json();
            if (data) {
              setGeoData(data);
              return;
            }
          }
        } catch (err) {
          console.warn(`Failed to load from ${url}:`, err);
        }
      }
    };
    
    fetchSyriaBorder();
  }, []);

  if (!geoData) return null;

  // Breathing effect - smooth sine wave for opacity and weight
  const breathValue = Math.sin((breathState / 120) * Math.PI * 2);
  const opacity = 0.6 + (breathValue * 0.4); // 0.2 to 1.0 (never goes to 0)
  const weight = 1.5 + (breathValue * 0.5); // 1.0 to 2.0

  return (
    <GeoJSON 
      key={`border-${breathState}`}
      data={geoData} 
      style={() => ({
        color: '#F5333F',
        weight: weight,
        opacity: opacity,
        fillColor: 'transparent',
        fillOpacity: 0,
        lineCap: 'round',
        lineJoin: 'round',
      })}
    />
  );
}

function FlyToLocation({ location }) {
  const map = useMap();
  useEffect(() => {
    if (location) {
      map.flyTo([location.lat, location.lng], 14, { duration: 1 });
    }
  }, [location, map]);
  return null;
}


function CustomMarker({ location, isDark, onSelect, isHighlighted, allLocations, currentZoom }) {
  const glowIntensity = useMemo(() => 
    calculateGlowIntensity(location, allLocations, currentZoom), 
    [location, allLocations, currentZoom]
  );
  
  const icon = useMemo(() => 
    createIcon(isDark, isHighlighted, glowIntensity), 
    [isDark, isHighlighted, glowIntensity]
  );

  const handleClick = useCallback(() => {
    onSelect(location);
  }, [location, onSelect]);

  return (
    <Marker
      position={[location.lat, location.lng]}
      icon={icon}
      eventHandlers={{ click: handleClick }}
    >
      <Tooltip 
        direction="top"
        offset={[0, -10]}
        opacity={1}
        className={`custom-tooltip ${isDark ? 'dark' : 'light'} ${isHighlighted ? 'highlighted' : ''}`}
      >
        <span>{location.name}</span>
      </Tooltip>
    </Marker>
  );
}

function LocationPanel({ location, onClose, isDark }) {
  if (!location) return null;
  return (
    <div className={`location-panel ${isDark ? 'dark' : 'light'}`}>
      <button className="close-btn" onClick={onClose} aria-label="Close">×</button>
      <div className="panel-content">
        <h2>{location.name}</h2>
        <div className="info-row">
          <span className="label">الإحداثيات</span>
          <span className="value">{location.lat.toFixed(6)}, {location.lng.toFixed(6)}</span>
        </div>
        {location.url && (
          <a href={location.url} target="_blank" rel="noopener noreferrer" className="map-link">
            فتح في خرائط جوجل
          </a>
        )}
      </div>
    </div>
  );
}

function SearchBox({ locations, onSelect, isDark }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (query.length > 1) {
      const filtered = locations.filter(loc => 
        loc.name.toLowerCase().includes(query.toLowerCase())
      ).slice(0, 6);
      setResults(filtered);
      setIsOpen(filtered.length > 0);
    } else {
      setResults([]);
      setIsOpen(false);
    }
  }, [query, locations]);

  const handleSelect = (loc) => {
    onSelect(loc);
    setQuery('');
    setIsOpen(false);
  };

  return (
    <div className={`search-box ${isDark ? 'dark' : 'light'}`}>
      <div className="search-input-wrap">
        <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input
          type="text"
          placeholder="ابحث عن موقع..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search locations"
        />
        {query && <button className="clear-btn" onClick={() => setQuery('')}>×</button>}
      </div>
      {isOpen && (
        <ul className="search-results">
          {results.map(loc => (
            <li key={loc.id} onClick={() => handleSelect(loc)}>
              <img src={isDark ? '/pin-light.png' : '/pin-dark.png'} alt="" className="result-pin" />
              <span className="result-name">{loc.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function Legend({ isDark }) {
  return (
    <div className={`map-legend ${isDark ? 'dark' : 'light'}`}>
      <h4>دليل الخريطة</h4>
      <div className="legend-item">
        <span className="legend-marker"></span>
        <span>موقع مسجل</span>
      </div>
      <div className="legend-hint">
        <span>💡</span>
        <span>انقر للتفاصيل</span>
      </div>
    </div>
  );
}


function MapComponent() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDark, setIsDark] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [highlightedId, setHighlightedId] = useState(null);
  const [currentZoom, setCurrentZoom] = useState(7);

  useEffect(() => {
    Papa.parse(csvData, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const validLocations = results.data
          .filter(row => {
            const lat = parseFloat(row.Latitude);
            const lng = parseFloat(row.Longitude);
            return !isNaN(lat) && !isNaN(lng) && row['Arabic Name'] && 
                   lat > 30 && lat < 40 && lng > 35 && lng < 42;
          })
          .map((row, index) => ({
            id: index,
            name: row['Arabic Name'],
            lat: parseFloat(row.Latitude),
            lng: parseFloat(row.Longitude),
            url: row['Source URL']?.replace(/"/g, '') || ''
          }));
        setLocations(validLocations);
        setLoading(false);
      }
    });
  }, []);

  const handleSearchSelect = (loc) => {
    setSelectedLocation(loc);
    setHighlightedId(loc.id);
    setTimeout(() => setHighlightedId(null), 5000);
  };

  const defaultCenter = useMemo(() => {
    if (locations.length === 0) return [33.5, 36.3];
    const avgLat = locations.reduce((sum, loc) => sum + loc.lat, 0) / locations.length;
    const avgLng = locations.reduce((sum, loc) => sum + loc.lng, 0) / locations.length;
    return [avgLat, avgLng];
  }, [locations]);

  const tileUrl = isDark
    ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
    : 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

  if (loading) {
    return (
      <div className={`loading-screen ${isDark ? 'dark' : 'light'}`}>
        <div className="loader"></div>
        <p>جاري تحميل المواقع...</p>
      </div>
    );
  }

  return (
    <div className={`app-container ${isDark ? 'dark' : 'light'}`}>
      <header className="app-header">
        <div className="header-inner">
          <div className="logo-area">
            <img src={isDark ? '/logo-light.png' : '/logo-dark.png'} alt="Defensafe" className="logo-img" />
          </div>
          <div className="header-title">
            <h1>خريطة المواقع</h1>
            <p>Location Intelligence Map</p>
          </div>
          <div className="header-actions">
            <div className="stats-pill">
              <span className="num">{locations.length}</span>
              <span className="txt">موقع</span>
            </div>
            <button className="theme-btn" onClick={() => setIsDark(!isDark)} aria-label="Toggle theme">
              <span className="theme-icon">{isDark ? '☀' : '☾'}</span>
            </button>
          </div>
        </div>
      </header>

      <main className="map-area">
        <Legend isDark={isDark} />
        
        <MapContainer center={defaultCenter} zoom={7} className="leaflet-map" scrollWheelZoom={true}>
          <TileLayer attribution='&copy; CARTO' url={tileUrl} />
          <SyrianBorder isDark={isDark} />
          <FitBounds locations={locations} />
          <FlyToLocation location={selectedLocation} />
          <ZoomTracker onZoomChange={setCurrentZoom} />
          <MarkerClusterGroup
            key={`cluster-${isDark ? 'dark' : 'light'}`}
            chunkedLoading
            maxClusterRadius={35}
            spiderfyOnMaxZoom={true}
            showCoverageOnHover={false}
            iconCreateFunction={(cluster) => {
              const count = cluster.getChildCount();
              const pinIcon = isDark ? '/pin-light.png' : '/pin-dark.png';
              
              return L.divIcon({
                html: `<div class="cluster-marker ${isDark ? 'dark' : 'light'}">
                  <img src="${pinIcon}" alt="" class="cluster-pin-icon" />
                  <span class="cluster-count">${count}</span>
                </div>`,
                className: 'custom-cluster-icon',
                iconSize: L.point(40, 50, true),
                iconAnchor: L.point(20, 50),
              });
            }}
          >
            {locations.map((loc) => (
              <CustomMarker 
                key={loc.id} 
                location={loc} 
                isDark={isDark} 
                onSelect={setSelectedLocation}
                isHighlighted={loc.id === highlightedId}
                allLocations={locations}
                currentZoom={currentZoom}
              />
            ))}
          </MarkerClusterGroup>
        </MapContainer>
        
        <LocationPanel location={selectedLocation} onClose={() => setSelectedLocation(null)} isDark={isDark} />
      </main>

      <footer className="app-footer">
        <div className="footer-inner">
          <div className="footer-left">
            <SearchBox locations={locations} onSelect={handleSearchSelect} isDark={isDark} />
          </div>
          <div className="footer-center">
            <span className="hint">💡 انقر للتفاصيل</span>
          </div>
          <div className="footer-right">
            <span>© {new Date().getFullYear()} Defensafe</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Password Protection Screen
function PasswordScreen({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    setTimeout(() => {
      if (password === MAP_PASSWORD) {
        sessionStorage.setItem(SESSION_KEY, 'authenticated');
        onSuccess();
      } else {
        setError('كلمة المرور غير صحيحة');
        setPassword('');
      }
      setIsLoading(false);
    }, 500);
  };

  return (
    <div className="password-screen">
      <div className="password-card">
        <div className="password-logo">
          <img src="/logo-light.png" alt="Defensafe" />
        </div>
        <h1>خريطة المواقع</h1>
        <p>هذه الخريطة محمية بكلمة مرور</p>
        
        <form onSubmit={handleSubmit}>
          <div className="password-input-wrap">
            <input
              type="password"
              placeholder="أدخل كلمة المرور"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              disabled={isLoading}
            />
          </div>
          {error && <div className="password-error">{error}</div>}
          <button type="submit" disabled={isLoading || !password}>
            {isLoading ? 'جاري التحقق...' : 'دخول'}
          </button>
        </form>
        
        <div className="password-footer">
          <span>© {new Date().getFullYear()} Defensafe. All rights reserved.</span>
        </div>
      </div>
    </div>
  );
}

// Main App with Password Protection
function ProtectedMapComponent() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const auth = sessionStorage.getItem(SESSION_KEY);
    if (auth === 'authenticated') {
      setIsAuthenticated(true);
    }
    setIsChecking(false);
  }, []);

  if (isChecking) {
    return (
      <div className="loading-screen dark">
        <div className="loader"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <PasswordScreen onSuccess={() => setIsAuthenticated(true)} />;
  }

  return <MapComponent />;
}

export default ProtectedMapComponent;